import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "master-new-form" }
const _hoisted_2 = { class: "border-bottom-white-darken-3 pb-3" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Riwayat Transaksi'))
const _hoisted_5 = { class: "mt-4 border-bottom-grey-4-dashed pb-3" }
const _hoisted_6 = { class: "md:flex items-center gap-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-base font-semibold text-grey" }, /*#__PURE__*/_toDisplayString('Nama Mandoran'), -1)
const _hoisted_8 = { class: "w-4/5 text-base font-semibold" }
const _hoisted_9 = { class: "md:flex items-center gap-4 mt-1" }
const _hoisted_10 = { class: "w-1/5 text-base font-semibold text-grey" }
const _hoisted_11 = { class: "w-4/5 text-base font-semibold" }
const _hoisted_12 = { class: "md:flex items-center gap-4 mt-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-base font-semibold text-grey" }, /*#__PURE__*/_toDisplayString('Email'), -1)
const _hoisted_14 = { class: "w-4/5 text-base font-semibold" }
const _hoisted_15 = { class: "mt-4 pb-3" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, "Riwayat transaksi Mandoran", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "text-primary pi pi-download" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Download PDF'), -1)
const _hoisted_20 = { class: "lg:flex items-center justify-between mt-32px" }
const _hoisted_21 = { class: "md:flex items-center gap-4" }
const _hoisted_22 = { id: "datePicker" }
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = { class: "w-full mt-3 md:mt-0 md:w-200px" }
const _hoisted_25 = { class: "w-full mt-3 md:mt-0 md:w-200px" }
const _hoisted_26 = { class: "mt-3 lg:mt-0" }
const _hoisted_27 = { class: "mt-32px" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Kembali")

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import { getCurrentInstance, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import { DatePicker } from 'v-calendar'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import moment from 'moment'
import EmptyState from '@/views/components/list/EmptyState.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import Paginator from '@/views/components/paginator/Paginator.vue'
import Button from 'primevue/button'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionHistory',
  setup(__props) {

const salesAgentTransactionsEndpoint = 'transaction/v2/SalesAgentTransactions'
const employeeEndpoint = 'talent/v1/employees'
const vehicleEndpoint = 'management/v1/MsVehicle'
const userEndpoint = 'management/v1/User'
const emptyTable = ref('Tidak ada transaksi')
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const store = useStore()
const route = useRoute()
const router = useRouter()
const mandoranId = ref(null) as any
const mandoranDataDetail = ref(null) as any
const dataSource = ref([]) as any
const selectedDate = ref<{ start: Date | null; end: Date | null }>({ start: null, end: null })
const selectedVehicle = ref(null) as any
const selectedConductor = ref(null) as any
const inputSearch = ref('')
const isLoading = ref(false)
const filters = ref({
  search: '',
  filterField: ['licensePlateNumber', 'conductorName'],
  pageNumber: 1,
  pageSize: 5,
  totalRecords: 0,
  custom: [] as any
})

const getDataDetailMandoran = async () => {
  // Fetch data detail mandoran
  store.dispatch('showLoading')
  await apiOpenUseCase.get(`${employeeEndpoint}/${mandoranId.value}`).then((res) => {
    console.log('Data detail mandoran:', res)
    mandoranDataDetail.value = res.result
  }).catch((err) => {
    console.error('Error fetching data detail mandoran:', err)
  })
  store.dispatch('hideLoading')
}

const getMandoranTransactionHistory = async () => {
  store.dispatch('showLoading')
  isLoading.value = true
  await apiUseCase.get(`${salesAgentTransactionsEndpoint}${returnUrlPrams(filters.value)}`).then((response) => {
    const { error, result, count } = response
    if (!error) {
      dataSource.value = result
      filters.value.totalRecords = count
    }
  })
  isLoading.value = false
  store.dispatch('hideLoading')
}

const setBreadcrumb = () => {
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Mandoran',
      routeName: 'master-mandoran'
    },
    {
      title: mandoranDataDetail.value?.fullName ?? '-',
      routeName: 'master-mandoran-form',
      params: { id: route.params.id }
    },
    {
      title: 'Riwayat Transaksi',
      routeName: 'master-mandoran-transaction-history',
      params: { id: route.params.id }
    }
  ])
}

const onVehicleChange = (option: any) => {
  selectedVehicle.value = option
  // eslint-disable-next-line no-use-before-define
  appliyFilter(option, 'vehicle')
}

const onConductorChange = (option: any) => {
  selectedConductor.value = option
  // eslint-disable-next-line no-use-before-define
  appliyFilter(option, 'conductor')
}

const clearDateFilter = () => {
  selectedDate.value = { start: null, end: null }
  // eslint-disable-next-line no-use-before-define
  appliyFilter(null, 'date')
}

const onSearch = () => {
  selectedDate.value = { start: null, end: null }
  selectedVehicle.value = null
  selectedConductor.value = null
  filters.value.custom = []
  filters.value.pageNumber = 1
  filters.value.search = inputSearch.value
  getMandoranTransactionHistory()
}

const appliyFilter = (option: any, filterType?: string) => {
  if (filterType === 'date') {
    if (option?.start || option?.end) {
      const startDate = option.start
        ? moment(option.start).format('YYYY-MM-DD')
        : moment().subtract(1, 'month').format('YYYY-MM-DD')
      const endDate = option.end ? moment(option.end).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')

      selectedDate.value = {
        start: startDate,
        end: endDate
      }
      filters.value.custom = filters.value.custom.filter(
        (customFilter: any[]) => !['StartDate', 'EndDate'].includes(customFilter[0])
      )
      filters.value.custom.push(
        ['StartDate', '=', startDate],
        ['EndDate', '=', endDate]
      )
      filters.value.pageNumber = 1
      getMandoranTransactionHistory()
      return
    }

    const existingDateFilters = filters.value.custom.filter(
      (customFilter: any[]) => ['StartDate', 'EndDate'].includes(customFilter[0])
    )
    filters.value.custom = filters.value.custom.filter(
      (customFilter: any[]) => !['StartDate', 'EndDate'].includes(customFilter[0])
    )

    if (existingDateFilters.length > 0) {
      filters.value.pageNumber = 1
      getMandoranTransactionHistory()
    }
    return
  }

  const filterConfig: Record<string, { field: string; value: any }> = {
    vehicle: {
      field: 'licensePlateNumber',
      value: option?.Nopol
    },
    conductor: {
      field: 'conductorName',
      value: option?.Fullname
    }
  }
  const selectedFilter = filterConfig[filterType || '']
  if (!selectedFilter) return

  const existingFilterIndex = filters.value.custom.findIndex(
    (customFilter: any[]) => customFilter[0] === selectedFilter.field
  )

  console.log('filters', filters.value)

  const isFilterCleared = option?.Id == null
  if (isFilterCleared) {
    if (existingFilterIndex !== -1) {
      filters.value.custom.splice(existingFilterIndex, 1)
    }

    getMandoranTransactionHistory()
    return
  }

  const selectedFilterValue = [selectedFilter.field, '=', selectedFilter.value]
  if (existingFilterIndex === -1) {
    filters.value.custom.push(selectedFilterValue)
  } else {
    filters.value.custom[existingFilterIndex] = selectedFilterValue
  }

  getMandoranTransactionHistory()
}

const onSort = (val: any) => {
  console.log('onSort', val)
  // filters.value.pageNumber = 1
  // orderByTable.value = `${val.sortField} ${val.sortOrder === 1 ? 'asc' : 'desc'}`
  // getData()
}

const onChangePage = ({ page, rows }: any) => {
  filters.value.pageNumber = page + 1
  filters.value.pageSize = rows
  // eslint-disable-next-line no-use-before-define
  getMandoranTransactionHistory()
}

const toPrevPage = () => {
  router.push({
    name: 'master-mandoran-form',
    params: { id: route.params.id }
  })
}

const printLog = async () => {
  console.log('printLog')
  store.dispatch('showLoading')
  const payload = {
    EmployeeId: mandoranId.value,
    StartDate: selectedDate.value.start ? moment(selectedDate.value.start).format('YYYY-MM-DD') : moment().subtract(1, 'month').format('YYYY-MM-DD'),
    EndDate: selectedDate.value.end ? moment(selectedDate.value.end).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
    vehicleId: selectedVehicle.value?.Id ?? null,
    CondecturId: selectedConductor.value?.Id ?? null,
  }
  await apiUseCase.postBlob(`${salesAgentTransactionsEndpoint}/GenerateReport`, payload).then((response) => {
    console.log('printLog response', response)
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Riwayat Transaksi Mandoran ${mandoranDataDetail.value?.fullName} (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

onMounted(async () => {
  mandoranId.value = encryptDecriptMethods.decrypt(route.params.id)
  console.log('mandoranId', encryptDecriptMethods.decrypt(route.params.id))
  filters.value.custom = [['employeeId', '=', mandoranId.value]]
  await getDataDetailMandoran()
  setBreadcrumb()
  getMandoranTransactionHistory()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("i", {
                class: "pi pi-angle-left font-bold text-xl cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toPrevPage()))
              }),
              _hoisted_4
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(`: ${_unref(mandoranDataDetail)?.fullName ?? '-'}`), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString('No. Telp'), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(`: ${_unref(mandoranDataDetail)?.phoneNumber ?? '-'}`), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(`: ${_unref(mandoranDataDetail)?.email ?? '-'}`), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", null, [
              _createVNode(_unref(Button), {
                class: "flex gap-2 extra-submit-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (printLog())),
                outlined: true
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_unref(DatePicker), {
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((selectedDate).value = $event)),
                      _cache[3] || (_cache[3] = (val) => appliyFilter(val, 'date'))
                    ],
                    modelModifiers: { range: true },
                    masks: { input: 'DD/MM/YYYY' }
                  }, {
                    default: _withCtx(({ togglePopover, inputValue }) => [
                      _createVNode(_unref(InputText), {
                        id: "transactionDate",
                        placeholder: "Rentang tanggal",
                        value: inputValue.start && inputValue.end ? `${inputValue.start} - ${inputValue.end}` : '',
                        class: "",
                        readonly: "",
                        onClick: togglePopover
                      }, null, 8, ["value", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (selectedDate.value.start || selectedDate.value.end)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "pi pi-times cursor-pointer",
                        title: "Hapus tanggal",
                        onClick: clearDateFilter
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(SelectAsync, {
                  endpoint: vehicleEndpoint,
                  classname: "custom-select w-full",
                  inputId: `vehicle`,
                  fieldLabel: (v) => `${v.Nopol}`,
                  searchFields: ['nopol'],
                  placeholder: 'Pilih Nopol',
                  modelValue: _unref(selectedVehicle),
                  "onUpdate:modelValue": onVehicleChange,
                  searchCustom: [['isActive', '=', 'true']]
                }, null, 8, ["fieldLabel", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(SelectAsync, {
                  endpoint: `${userEndpoint}/all-user`,
                  classname: "custom-select w-full",
                  inputId: `condectur`,
                  fieldLabel: (v) => `${v.Fullname}`,
                  searchFields: ['name'],
                  placeholder: 'Pilih Kondektur',
                  modelValue: _unref(selectedConductor),
                  "onUpdate:modelValue": onConductorChange,
                  searchCustom: [['roles', '=', 'Condectur']]
                }, null, 8, ["endpoint", "fieldLabel", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(InputIconRight, {
                class: "input-search-header-custom",
                placeholder: 'Cari nopol atau nama kondektur',
                modelValue: inputSearch.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputSearch).value = $event)),
                canClick: true,
                icon: _unref(icon).svg.searchEva,
                onSubmitInput: onSearch,
                onKeyup: _withKeys(onSearch, ["enter"])
              }, null, 8, ["modelValue", "icon", "onKeyup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(DataTable), {
              id: "hjp-data-table",
              value: _unref(dataSource),
              paginator: false,
              loading: isLoading.value,
              class: "table-og hjp-data-table",
              responsiveLayout: "scroll",
              onSort: onSort
            }, {
              empty: _withCtx(() => [
                _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
              ]),
              loading: _withCtx(() => [
                _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(Column), { header: "TANGGAL" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(moment)(slotProps.data.CreatedAt).format('DD/MM/YYYY - HH:mm:ss')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "NOPOL" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(slotProps.data.LicensePlateNumber ?? '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "KONDEKTUR" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(slotProps.data.ConductorName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "PENUMPANG" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(`${_unref(numberFormat)(slotProps.data.TicketQuantity ?? 0)} orang`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "KOMISI RIT" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(rupiahFormat)(slotProps.data.RitCommission ?? 0)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "KOMISI PENUMPANG" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(rupiahFormat)(slotProps.data.TicketCommission ?? 0)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), { header: "TOTAL KOMISI" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(rupiahFormat)((slotProps.data.RitCommission ?? 0) + (slotProps.data.TicketCommission ?? 0))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "loading"]),
            _createVNode(Paginator, {
              rows: filters.value.pageSize,
              totalRecords: filters.value.totalRecords,
              rowsPerPageOptions: [5, 10],
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_unref(Button), {
            class: "btn-back",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (toPrevPage()))
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})